import { createFileRoute, redirect } from '@tanstack/react-router';
import { DEFAULT_SECTION_SLUG } from '@/domains/docs/constants';

// Ruta PÚBLICA. Todos los documentos abren en su «Introducción».
export const Route = createFileRoute('/docs/$docId/')({
    beforeLoad: ({ params }) => {
        throw redirect({
            to: '/docs/$docId/$sectionId',
            params: { docId: params.docId, sectionId: DEFAULT_SECTION_SLUG },
        });
    },
});
